/* global google */

// import './css/main.css';
// import './css/demo.css';
// import './vendor/browser.min.js';
// import './vendor/breakpoints.min.js';
// import markerIconUrl from './images/spotlight-poi2_hdpi.png';
//
// const RoundwareWebFramework = require('./vendor/roundware.umd.min.js');
import $ from "jquery";
import { isMobile, browser } from "./responsive";
import { wobble } from "./util";
import { roundware, ROUNDWARE_INITIAL_LATITUDE, ROUNDWARE_INITIAL_LONGITUDE, ROUNDWARE_SERVER_BASE_URL } from "./roundware";
import MarkerClusterer from "@google/markerclustererplus";
import markerImgUrl from "../../images/map-markerB.png"
import { OverlappingMarkerSpiderfier } from "ts-overlapping-marker-spiderfier";
require("gasparesganga-jquery-loading-overlay");

console.log(browser);
if (isMobile) {
  console.log("Mobile/tablet device detected");
  $("#menu-listen").hide();
} else {
  console.log("Desktop device detected");
  $("#menu-mobile").hide();
}

let activeInfoWindow;

const roundwareConnectionPromise = new Promise((resolve, reject) => {
  roundware.
    connect().
    then(connectParams => resolve(connectParams)).
    catch(err => {
      console.error('Roundware unable to connect', err);
      reject('We were unable to connect to Roundware due to error, please try again.');
    });
});

/**
 * Calculates the distance between two {@link Point|points} in degress, radians,
 * miles, or kilometers. This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula)
 * to account for global curvature.
 *
 * Modified from https://github.com/Turfjs/turf-distance/blob/a79f9dcc4402e0244fbcd3b7f36d9b361d9032bf/index.js */
function distance(coordinates1, coordinates2) {
  const dLat = toRad(coordinates2[1] - coordinates1[1]);
  const dLon = toRad(coordinates2[0] - coordinates1[0]);
  const lat1 = toRad(coordinates1[1]);
  const lat2 = toRad(coordinates2[1]);

  const a = Math.pow(Math.sin(dLat / 2), 2) +
    Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distanceInKm = 6373 * c;
  return distanceInKm;
}

function toRad(degree) {
  return degree * Math.PI / 180;
}

function voteAsset(assetId, voteType, value) {
  console.log(`Asset #${assetId}: vote registered`);
  roundware.vote(assetId, voteType, value);
  if (voteType === "flag") {
    $(`#${voteType}${assetId}`).css('color', 'red');
  } else if (voteType === "like") {
    $(`#${voteType}${assetId}`).css('color', 'blue');
  }
  // disallow multiple votes
  $(`#${voteType}${assetId}`).off('click');
}

function mapSpeakers(map, roundware) {
  const speakers = roundware.speakers();

  speakers.forEach(item => {
    map.data.addGeoJson({
      "type": "Feature",
      "geometry": item.shape,
      "properties": {
        "speaker_id": item.id,
        "title": "outer"
      }
    });

    map.data.addGeoJson({
      "type": "Feature",
      "geometry": item.attenuation_border,
      "properties": {
        "speaker_id": item.id,
        "title": "inner"
      }
    });

    map.data.setStyle(function(feature) {
      if (feature.getProperty('name') == "outer") {
        return {
          fillColor: '#aaaaaa',
          fillOpacity: .5,
          strokeWeight: 1,
          strokeOpacity: .5
        };
      }
      else if (feature.getProperty('name') == "inner") {
        return {
          fillColor: '#555555',
          fillOpacity: 0,
          strokeWeight: 1,
          strokeOpacity: .2
        };
      }
    });
  });
}

async function mapAssets(map, oms, listener) {
  const assets = await roundware.loadAssetPool();
  const assetMarkers = [];
  let markerImage = {
    url: markerImgUrl,
    // This marker is 50 pixels wide by 50 pixels high.
    scaledSize: new google.maps.Size(30, 30),
    // The origin for this image is (0, 0).
    origin: new google.maps.Point(0, 0),
    // The anchor for this image is the base of the point.
    anchor: new google.maps.Point(15, 30)
  };

  assets.forEach(item => {
    const point = new google.maps.LatLng(wobble(item.latitude, .01), wobble(item.longitude, .01));

    const marker = new google.maps.Marker({
      map,
      position: point,
      icon: markerImage
    });

    marker.id = item.id;
    marker.rw_tags = [];

    if (item.tag_ids) {
      marker.rw_tags = item.tag_ids;
    }

    const { id: itemId, file, volume, created = '', weight, tag_ids } = item;

    const tagHtml = tag_ids.map(t => '<p class="infoTagText">' + roundware.findTagDescription(t) + "</p>").join("");
    const date = new Date(created);
    const dateHtml = '<p class="infoDateText"><em>' + date.toDateString() + '</em></p>';

    const contentOld = `
    <p><b>Asset ${itemId}</b></br>
    <em>${file}</em></br></p>
    <table>
      <tr><th>Volume</th><td>${volume}</td></tr>
      <tr><th>Created</th><td>${created.slice(0, 19)}</td></tr>
      <tr><th>Weight</th><td>${weight}</td></tr>
      <tr><th>Tags</th><td>${tag_ids}</td></tr>
    </table>`;

    const filePathMp3 = ROUNDWARE_SERVER_BASE_URL + "rwmedia/" +
                        item.filename.substring(0, item.filename.lastIndexOf('.')).concat(".mp3");
    const filePathWav = ROUNDWARE_SERVER_BASE_URL + "rwmedia/" +
                        item.filename.substring(0, item.filename.lastIndexOf('.')).concat(".wav");

    const content = `
    ${tagHtml}
    ${dateHtml}
    <div id="infoVoteBlock">
    <span id="like${itemId}"
             class="icon solid fa-thumbs-up infoLike"
             alt="tell us you like this one!">
    </span>
    <span id="flag${itemId}"
             class="icon solid fa-flag infoFlag"
             alt="flag this content for review">
    </span>
    <span id="link${itemId}"
             class="icon solid fa-link infoLink"
             alt="go to contribution page">
    </span>
    <span id="download${itemId}"
             class="icon solid fa-download infoDownload"
             alt="download this audio file">
    </span>
    </div>
    <audio controls preload="none" controlsList="nodownload">
    <source src="${filePathMp3}" type="audio/mp3" >
    <source src="${filePathWav}" type="audio/wav" >
    Your browser does not support audio!
    </audio>`;

    const infoWindow = new google.maps.InfoWindow({ content });

    marker.addListener('spider_click', function() {
      if (activeInfoWindow) { activeInfoWindow.close(); }
      infoWindow.open(map, marker);
      activeInfoWindow = infoWindow;

      const assetLocationPoint = [
        marker.position.lng(),
        marker.position.lat()
      ];

      const listenerLocationPoint = [
        listener.position.lng(),
        listener.position.lat()
      ];

      const dist = distance(listenerLocationPoint, assetLocationPoint);

      console.info(`Asset #${marker.id}: ${dist.toFixed(1)}km from listener`);
    });

    google.maps.event.addListener(infoWindow,'domready',function(){
        $(`#flag${itemId}`).click(function() {
            voteAsset(itemId, 'flag');
        });
    });
    google.maps.event.addListener(infoWindow,'domready',function(){
        $(`#like${itemId}`).click(function() {
            voteAsset(itemId, 'like');
        });
    });
    google.maps.event.addListener(infoWindow,'domready',function(){
        $(`#link${itemId}`).click(function() {
            const url = `./s.html?eid=${item.envelope_ids[0]}`
            console.log(url);
            window.location.href = url;
        });
    });
    google.maps.event.addListener(infoWindow,'domready',function(){
        $(`#download${itemId}`).click(function() {
            fetch(`${filePathMp3}`, {
                headers: new Headers({
                    'Origin': location.origin
                }),
                mode: 'cors'
            })
            .then(response => response.blob())
            .then(blob => {
                let blobUrl = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.download = `corona_diaries_${itemId}`;
                a.href = blobUrl;
                // For Firefox https://stackoverflow.com/a/32226068
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
            .catch(e => console.error(e));
        });
    });

    // display asset shape if exists
    if (item.shape) {
      marker.shape = new google.maps.Data();
      marker.shape.addGeoJson({
        "type": "Feature",
        "geometry": item.shape,
        "properties": {
          "asset_id": item.id,
          "name": "assetRange"
        }
      });

      marker.shape.setStyle(feature => {
        if (feature.getProperty('name') === "assetRange") {
          return {
            fillColor: '#6292CF',
            fillOpacity: .25,
            strokeWeight: 1,
            strokeOpacity: .8,
            strokeColor: '#6292CF'
          };
        } else {
          return {};
        }
      });
    } else {
      // if no asset shape, display default circle range
      const circle = {
        strokeColor: '#6292CF',
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: '#6292CF',
        fillOpacity: 0.25,
        map: map,
        center: new google.maps.LatLng(item.latitude, item.longitude),
        radius: roundware._project.recordingRadius
      };

      // marker.circle = new google.maps.Circle(circle);
    }

    assetMarkers.push(marker);
  });

  showHideMarkers(map, oms, assetMarkers);
  return assetMarkers;
}

function showHideMarkers(map, oms, assetMarkers) {
  const cluster = new MarkerClusterer(map, assetMarkers, {
    maxZoom: 12,
    minimumClusterSize: 3,
    imagePath: "https://github.com/googlemaps/v3-utility-library/raw/master/packages/markerclustererplus/images/m"
  });
  assetMarkers.forEach(m => oms.addMarker(m));
  // assetMarkers.forEach(item => {
  // if any item tags are not included in selected tags, hide marker, otherwise show it
  //const selectedListenTagIds = $("#uiListenDisplay input:checked").map(function() {
  //return Number(this.value);
  //}).get();

  //let is_visible = true;

  //const { rw_tags = [] } = item;

  //rw_tags.forEach((j,tag_id) =>{
  //// if tag_id isn't selected, set to false and return
  //if (!(selectedListenTagIds.includes(tag_id))) {
  //is_visible = false;
  //return;
  //}
  //});

  // const is_visible = true;

  // item.setVisible(is_visible);

  // if (item.circle) {
  //   item.circle.setVisible(is_visible);
  // }
  // if (item.shape) {
  //   if (is_visible) {
  //     item.shape.setMap(map);
  //   } else if (!is_visible) {
  //     item.shape.setMap(null);
  //   }
  // }
  // });
}

const drawListeningCircle = (map, center, radius) => (
  new google.maps.Circle({
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.35,
    map,
    center,
    radius
  })
);

// This function is intended to be invoked by the google API callback; see index.html
/* eslint-disable-next-line no-unused-vars */
async function initDemo() {
  console.log("init started");
  const listenMapEl = document.getElementById('mixMap');
  const playPauseBtn = document.getElementById('playPauseBtn');
  // const transportBtn = document.getElementById('transportBtn');

  // display overlay instructions
  $(listenMapEl).LoadingOverlay("show", {
    background: "rgba(0, 0, 0, 0.8)",
    text: "Tap the pins to listen to the stories!",
    textColor: "#cccccc",
    // imageColor: "#cccccc",
    image: "",
    maxSize: "60px"
  });
  setTimeout(function(){
    $(listenMapEl).LoadingOverlay("hide", true);
    console.log("hide map overlay");
  }, 2000);

  const googleMapsCenter = {
    lat: 25.0,
    lng: 20.0
  };

  var styledMapType = new google.maps.StyledMapType([
    {
      "featureType": "administrative",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#444444"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [
        {
          "color": "#f2f2f2"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [
        {
          "saturation": -100
        },
        {
          "lightness": 45
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "all",
      "stylers": [
        {
          "color": "#dbdbdb"
        },
        {
          "visibility": "on"
        }
      ]
    }
  ],
    { name: 'Corona Style' });

  const map = new google.maps.Map(listenMapEl, {
    zoom: 3,
    maxZoom: 18,
    center: googleMapsCenter,
    mapTypeControl: true,
    streetViewControl: false,
    fullscreenControl: false,
    rotateControl: false,
    mapTypeId: google.maps.MapTypeId.ROAD, // HYBRID
    mapTypeControlOptions: {
      mapTypeIds: ['satellite', 'hybrid', 'styled_map']
    },
    mapTypeControlOptions: {
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: google.maps.ControlPosition.BOTTOM_LEFT
    },
  });
  map.mapTypes.set('styled_map', styledMapType);
  map.setMapTypeId('styled_map');

  const oms = new OverlappingMarkerSpiderfier(map, {
    markersWontMove: true,
    markersWontHide: true,
    basicFormatEvents: true,
  });

  const listenerMapIcon = {
    url: "https://www.google.com/intl/en_us/mapfiles/ms/micons/green-dot.png",
    scaledSize: new google.maps.Size(0, 0)
  };

  const listener = new google.maps.Marker({
    position: googleMapsCenter,
    map,
    draggable: true,
    backgroundColor: '#555',
    draggableCursor: 'default',
    icon: listenerMapIcon
  });

  try {
    const { uiConfig } = await roundwareConnectionPromise;
    // mapSpeakers(map,roundware);
    // const mixer = await roundware.activateMixer();

    const assetMarkers = mapAssets(map, oms, listener);

    const { recordingRadius = 25 } = roundware.mixParams;

    // let listeningCircle = drawListeningCircle(map,googleMapsCenter,recordingRadius);

    const updateMapFromPosition = position => {
      // mixer.toggle();
      // listeningCircle.setMap(null);
      map.setCenter(position);
      // listeningCircle = drawListeningCircle(map,position,recordingRadius);
    };

    const updateMapFromGeolocation = location => {
      const { latitude: lat, longitude: lng } = location;
      const position = { lat, lng };
      updateMapFromPosition(position, recordingRadius);
    };

    google.maps.event.addListener(listener, "dragend", () => {
      const position = listener.getPosition();
      const latitude = position.lat();
      const longitude = position.lng();

      roundware.disableGeolocation();
      roundware.updateLocation({ latitude, longitude });
      updateMapFromPosition(position);
    });

    roundware.onUpdateLocation = listenerLocation => {
      // updateMapFromGeolocation(listenerLocation);
    };

    playPauseBtn.addEventListener('click', () => {
      const isPlaying = mixer.toggle();
      playPauseBtn.textContent = isPlaying ? 'Pause' : 'Play';
    });

    // transportBtn.addEventListener('click',() => {
    //   roundware.updateLocation({
    //     latitude: ROUNDWARE_INITIAL_LATITUDE,
    //     longitude: ROUNDWARE_INITIAL_LONGITUDE
    //   });
    //
    //   transportBtn.remove();
    //   roundware.disableGeolocation();
    // },{ once: true });

    const tagDiv = document.getElementById("tagSelection");

    const { listen: listenTags } = uiConfig;

    listenTags.forEach(tag => {
      const { header_display_text, display_items } = tag;

      tagDiv.insertAdjacentHTML('afterbegin', `<h2>${header_display_text}</h2>`);

      const checkboxEls = display_items.map(item => {
        const { tag_id, tag_display_text, default_state } = item;
        const checkedAttrib = default_state ? 'checked' : '';

        return `
          < label >
          <input id='tag_checkbox_${tag_id}' type='checkbox' name='tags' value='${tag_id}' ${checkedAttrib} />
        ${ tag_display_text} (#${tag_id})
          </label >
        <br />
      `;
      });

      tagDiv.insertAdjacentHTML('beforeend', checkboxEls.join('\n'));
      // tagDiv.style.display = 'block';
    });

    // playPauseBtn.style.display = 'block';
    // transportBtn.style.display = 'block';

    tagDiv.addEventListener('input', () => {
      const listenTagIds = [...tagDiv.querySelectorAll('[name=tags]:checked')].map(tag => tag.value);
      mixer.updateParams({ listenTagIds });
    });
  } catch (err) {
    const errBox = document.getElementById('errorDisplay');
    errBox.style.display = 'block';
    errBox.appendChild(document.createTextNode(err));
    console.error(err);
  }
}

const googleMapsApiKey = "AIzaSyCmYUeVE8rq7no5-uWa1Js1JCY154WM8Is"; // in development mode, set the file '.env' for this value
const scriptTag = document.createElement('script');
window.initDemo = initDemo; // so google maps API can see the callback, below

let src = 'https://maps.googleapis.com/maps/api/js?callback=initDemo';

if (googleMapsApiKey !== '') {
  src = src + '&key=' + googleMapsApiKey;
}

scriptTag.src = src;

document.body.appendChild(scriptTag);
